//Update the modal data
export const setModal = (data) => {
  return { type: "SET_MODAL", payload: data };
};

//Display the modal
export const showModal = (data) => {
  return { type: "SHOW_MODAL", payload: data };
};
